module.exports = __webpack_public_path__ + "media/bootstrap-icons/cash-coin-b9d285dc.svg";